<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <ion-list>
        <ion-item
          detail="true"
          button
          @click="navigateToReport('Transaction List')"
          data-cy="transactions-report"
        >
          <ion-label>
            <h2>
              Transactions Report
            </h2>
            <p>
              The transaction report shows transactions over a period with a
              focus on revenue per order.
            </p>
          </ion-label>
        </ion-item>
        <ion-item
          detail="true"
          button
          @click="navigateToReport('Reconciliation Report')"
          data-cy="reconciliation-report"
        >
          <ion-label>
            <h2>
              Reconciliation Report
            </h2>
            <p>
              A detailed report for transactions, order details and fees for a
              daily reconciliation at a specific location.
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  title: "Reports",

  methods: {
    navigateToReport(name) {
      this.$router.push({
        name: "Web: " + name
      });
    }
  },

  created() {
    if (!this.userIsAdmin && !this.userIsVendor) {
      return this.$router.push("/").catch(e => e);
    }
  },

  computed: {
    ...mapGetters("auth", ["userIsAdmin", "userIsVendor"])
  }
};
</script>
